import { CrownIcon, ShieldIcon, UserIcon } from "lucide-react";

import { ProjectRoleType } from "@/features/projects/types";

export const ROLE_CONFIG: Record<ProjectRoleType, { icon: React.ElementType; className: string; description: string; badgeClass: string }> = {
  Admin: {
    icon: CrownIcon,
    className: "text-amber-600 dark:text-amber-400",
    description: "Full access - can manage members, settings and all tickets.",
    badgeClass: "text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30",
  },
  Developer: {
    icon: ShieldIcon,
    className: "text-primary",
    description: "Can create, edit and close tickets. Cannot manage members.",
    badgeClass: "text-primary border-primary/20 bg-primary/5",
  },
  Viewer: {
    icon: UserIcon,
    className: "text-muted-foreground",
    description: "Read-only access to tickets and project information.",
    badgeClass: "text-muted-foreground border-border bg-muted",
  },
};

export const ROLE_PERMISSIONS: Record<ProjectRoleType, { label: string; allowed: boolean }[]> = {
  Admin: [
    { label: "View tickets", allowed: true },
    { label: "Create & edit tickets", allowed: true },
    { label: "Close & delete tickets", allowed: true },
    { label: "Manage members & roles", allowed: true },
    { label: "Edit project settings", allowed: true },
    { label: "Delete project", allowed: true },
  ],
  Developer: [
    { label: "View tickets", allowed: true },
    { label: "Create & edit tickets", allowed: true },
    { label: "Close & delete tickets", allowed: true },
    { label: "Manage members & roles", allowed: false },
    { label: "Edit project settings", allowed: false },
    { label: "Delete project", allowed: false },
  ],
  Viewer: [
    { label: "View tickets", allowed: true },
    { label: "Create & edit tickets", allowed: false },
    { label: "Close & delete tickets", allowed: false },
    { label: "Manage members & roles", allowed: false },
    { label: "Edit project settings", allowed: false },
    { label: "Delete project", allowed: false },
  ],
};

export const PROJECT_ROLES: ProjectRoleType[] = ["Admin", "Developer", "Viewer"];
